import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownResourceTypes = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    const [ loading, items ] = useListboxFetch( { url: '/resources/types', keyFieldName: 'rt_id', labelFieldName: 'rt_name', additionalFields: [] } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownResourceTypes;
